import { PROVINCE, findProvincia } from "@/lib/province";

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export const EMPTY = {
  nome: "", whatsapp: "+39 ", titolare: "", nome_centro: "", citta: "", provincia: "", regione: "",
  cabine: "", cliente_skinlovers: "", ragione_sociale: "", partita_iva: "", sdi_pec: "", email: "",
  consenso_privacy: false, consenso_marketing: false,
};

export function validate(step, d) {
  const e = {};
  if (step === 1) {
    if ((d.nome || "").trim().split(/\s+/).filter(Boolean).length < 2) e.nome = "Scrivi nome e cognome.";
    const digits = (d.whatsapp || "").replace(/\D/g, "");
    if (digits.length < 10 || digits.length > 15) e.whatsapp = "Inserisci un numero WhatsApp valido, con prefisso (es. +39 333 123 4567).";
  }
  if (step === 2) {
    if (d.titolare !== "si") e.titolare = d.titolare === "no" ? "Il workshop è riservato alle titolari." : "Indica se sei la titolare del centro.";
    if (!d.nome_centro.trim()) e.nome_centro = "Scrivi il nome del tuo centro.";
    if (!d.citta.trim()) e.citta = "Scrivi la città del centro.";
    if (!findProvincia(d.provincia)) e.provincia = "Scegli una provincia dall'elenco.";
    if (!d.regione.trim()) e.regione = "Indica la regione.";
    if (!d.cabine) e.cabine = "Scegli il numero di cabine.";
    if (!d.cliente_skinlovers) e.cliente_skinlovers = "Rispondi Sì o No.";
  }
  if (step === 3) {
    if (!d.ragione_sociale.trim()) e.ragione_sociale = "Scrivi la ragione sociale del centro.";
    if (!/^\d{11}$/.test(d.partita_iva.replace(/\s/g, ""))) e.partita_iva = "La Partita IVA deve avere 11 cifre.";
    const sdi = d.sdi_pec.trim();
    if (!/^[A-Za-z0-9]{7}$/.test(sdi) && !EMAIL.test(sdi)) e.sdi_pec = "Inserisci un codice SDI di 7 caratteri o un indirizzo PEC valido.";
    if (!EMAIL.test(d.email.trim())) e.email = "Inserisci un indirizzo email valido.";
    if (!d.consenso_privacy) e.consenso_privacy = "Per continuare devi accettare l'informativa privacy.";
  }
  return e;
}

export const provinceCount = PROVINCE.length;
